
/**
 * @param {HTMLElement} question 
 */
function initFAQQuestion(question){
   let heading = question.querySelector("[data-faq-heading]");

   /** @type {HTMLElement} */
   let answer = question.querySelector("[data-faq-answer]");
   
   if(!heading || !answer) return;

   let open = false;

   let sync = (animate)=>{
      if(animate){
         if(open){
            answer.classList.remove("animate");
            answer.setAttribute("style", "");
            let height = answer.offsetHeight;
            answer.style.maxHeight = "0px";
            answer.offsetHeight; // Yes, touching :)
            answer.classList.add("animate");
   
            answer.style.maxHeight = height + "px";
         }else{
            answer.classList.remove("animate");
            answer.setAttribute("style", "");
            let height = answer.offsetHeight;
            answer.style.maxHeight = height + "px";
            answer.offsetHeight; // Yes, touching :)
            answer.classList.add("animate");
   
            answer.style.maxHeight = "0px";
         }
         question.classList.toggle("collapsed", !open);
      }
      else{
         answer.style.maxHeight = open ? "auto" : "0px";
         question.classList.toggle("collapsed", !open);
      }
   };

   sync(false);


   heading.addEventListener("click", ()=>{
      open = !open;
      
      sync(true);
   });
}

export function initFAQQuestions(){
   let elements = document.querySelectorAll("[data-faq-question]");

   elements.forEach(element => {
      initFAQQuestion(element);
   });
}